<template>
<!--  <el-select class="mentor_content_selectBox" v-model="value" placeholder="지역 전체" @change="setFilterFunc('ac',value)">-->
<!--    <el-option-->
<!--        v-for="item in areaList"-->
<!--        :key="item.ac_idx"-->
<!--        :label="item.is_city_name"-->
<!--        :value="item.ac_idx">-->
<!--    </el-option>-->
<!--  </el-select>-->
</template>

<script>

import memberUtil from "@/components/member/memberUtil";
import util from "@/mixins/util";

const {filterConfig} = memberUtil;
export default {
  name: "MemberFilterDefaultLayout",
  mixins: [memberUtil],
  components: {},
  inject: ['setPage', 'memberListSetData', 'setFilter'],
  provide() {
    return {}
  },
  props: {
    filterData: {
      default: {}
    },
    areaList: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      value: '',
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setFilterFunc(key, value) {
      let classname = filterConfig[key].classname;
      if (!classname) {
        return;
      }
      this[classname] = value;
      this.memberListSetData(classname, value);
      this.setFilter(key, value);
    },

  },
  watch: {}
  ,
}
</script>

<style scoped>

</style>